import script from "./VideosView.vue?vue&type=script&setup=true&lang=js"
export * from "./VideosView.vue?vue&type=script&setup=true&lang=js"

import "./VideosView.vue?vue&type=style&index=0&id=89d69c56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89d69c56"]])

export default __exports__